import { isCsMemoDeleteUnsupported } from '@shared/api/giftCsMemo/giftCsMemo.controller';
import {
  useCreateGiftCsMemo,
  useDeleteGiftCsMemo,
  useGiftCsMemoCache,
  useGiftCsMemoListQuery,
} from '@shared/api/giftCsMemo/giftCsMemo.hook';
import {
  GiftCsMemo,
  GiftCsMemoTarget,
  resolveCsMemoTarget,
} from '@shared/api/giftCsMemo/giftCsMemo.interface';
import { CsMemoAdapter, CsMemoRecord } from '@shared/components/csMemo';

// 공용 CS 메모 UI(@shared/components/csMemo)에 답례품 도메인 훅을 연결하는 어댑터.

const useGiftMemoList = (target: GiftCsMemoTarget, enabled: boolean) => {
  const { data, isLoading } = useGiftCsMemoListQuery(target, enabled);
  return { data, isLoading };
};

const useGiftMemoCache = (target: GiftCsMemoTarget) => useGiftCsMemoCache(target);

const useGiftMemoCreate = () => {
  const mutation = useCreateGiftCsMemo();
  return {
    mutateAsync: (input: GiftCsMemoTarget & { body: string; adminOnly?: boolean }) =>
      mutation.mutateAsync(input),
    isLoading: mutation.isLoading,
  };
};

const useGiftMemoDelete = () => {
  const mutation = useDeleteGiftCsMemo();
  return {
    // 이 어댑터가 돌려준 메모만 들어오므로 도메인 타입으로 되돌려도 안전
    mutateAsync: ({ memo }: { memo: CsMemoRecord }) =>
      mutation.mutateAsync({ memo: memo as GiftCsMemo }),
    isLoading: mutation.isLoading,
  };
};

export const giftCsMemoAdapter: CsMemoAdapter<GiftCsMemoTarget> = {
  useList: useGiftMemoList,
  useCache: useGiftMemoCache,
  useCreate: useGiftMemoCreate,
  useDelete: useGiftMemoDelete,
  isDeleteUnsupported: isCsMemoDeleteUnsupported,
  roleBadge: (byRole) =>
    byRole === 'Admin'
      ? { label: '관리자', className: 'bg-indigo-100 text-indigo-700' }
      : { label: '마리', className: 'bg-teal-100 text-teal-700' },
  hasTarget: (target) => !!resolveCsMemoTarget(target),
};

/** 구독만 끄기 위한 빈 타깃 (키 'none' — 조회되지 않는다) */
export const GIFT_CS_MEMO_EMPTY_TARGET: GiftCsMemoTarget = {};
